import React from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  const scrollToAbout = () => {
    const element = document.getElementById('about-preview');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigateToServices = () => {
    navigate('/services');
  };

  const navigateToContact = () => {
    navigate('/contact');
  };

  return (
    <section id="home" className="hero">
      <div className="hero-overlay"></div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Empowering Businesses with <span className="highlight">Insight, Integrity & Innovation</span>
          </h1>
          <p className="hero-subtitle">
            A multidisciplinary Chartered Accountancy firm delivering excellence in Audit, Advisory, Information Security, Data Analytics, and Technology-enabled verification solutions.
          </p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={navigateToServices}>Explore Our Services</button>
            <button className="btn-secondary" onClick={navigateToContact}>Submit an Enquiry</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
